var map = {
	"./0iconmonstr-paintbrush-7.svg": 2307,
	"./1blueWood.png": 4121,
	"./2redWood.png": 4222,
	"./3greenWood.png": 3172,
	"./4goldWood.png": 7963,
	"./5grayWood.png": 3590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4049;